/** Subscription fuel gauge (PRD §35.2): a small ring per window; amber ≥ 70 %, red ≥ 90 %. */
export function UsageGauge({ label, value }: { label: string; value: number | null }) {
  const v = value == null ? 0 : Math.max(0, Math.min(100, value));
  const tone = value == null ? "neutral" : v >= 90 ? "danger" : v >= 70 ? "attention" : "ok";
  const r = 9, c = 2 * Math.PI * r;
  return (
    <span className={`gauge tone-${tone}`} aria-hidden>
      <svg width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r={r} className="gauge-track" /><circle cx="12" cy="12" r={r} className="gauge-fill" strokeDasharray={`${(v / 100) * c} ${c}`} transform="rotate(-90 12 12)" /></svg>
      <span className="gauge-text">{label}<b>{value == null ? "–" : Math.round(v)}</b></span>
    </span>
  );
}
